import { useState, useEffect } from "react";
import { categoryList, techSupport } from "apiHandler/actions";
import SuccessModal from "components/modals/supportSuccess";
import { useUserData } from "components/customHooks/userDataContext";

const Support = () => {
  const [categories, setCategories] = useState([]);
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [refId, setRefId] = useState("");

  const [error, setError] = useState({
    number: "",
    category: "",
    message: "",
  });
  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    const getCategoryList = async () => {
      let categories = await categoryList(token);
      if (Array.isArray(categories)) setCategories(categories.categoryList);
    };
    getCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = async () => {
    let number_ = "";
    let category_ = "";
    let message_ = "";
    if (number.toString().length !== 10)
      number_ = "Contact Number must be 10 digits.";
    if (!category) category_ = "Please Select Category";
    if (!message) message_ = "Please Enter Message";
    setError({
      number: number_,
      category: category_,
      message: message_,
    });
    if (!number_ && !category_ && !message_) return true;
    return false;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let validated = await validate();
    if (!validated) return;
    let payload = {
      // uuid: isAuthenticated().uuid,
      contactNum: number,
      email: email,
      subject: category,
      message: message,
    };
    let response = await techSupport(payload, token);
    if (response !== "ERROR") {
      setRefId(response.inquiryId);
      setShowSuccessModal(true);
      clearState();
    }
  };

  const clearState = () => {
    setEmail("");
    setNumber("");
    setCategory("");
    setMessage("");
    setError({
      number: "",
      category: "",
      message: "",
    });
  };

  const onCloseModal = () => {
    setRefId("");
    setShowSuccessModal(false);
  };

  return (
    <div className="provider-support-container">
      <p className="title">Need Help?</p>
      <p className="title">Feel free to reach out to us!</p>
      <form className="form-container">
        <label className="label-style">Email Id (Optional)</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail"
          className="input-style"
        />

        <label className="label-style">
          Contact Number
          <span className="required">*</span>
        </label>
        <input
          type="number"
          value={number}
          onChange={(e) => {
            if (e.target.value.toString().length <= 10)
              setNumber(e.target.value);
          }}
          placeholder="Contact Number"
          className="input-style"
        />
        <span className="error">{error.number}</span>

        <label className="label-style mt-16">
          Category
          <span className="required">*</span>
        </label>
        <select
          className="input-style"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="">-Select-</option>
          {categories?.map((c) => (
            <option value={c} key={c}>
              {c}
            </option>
          ))}
        </select>
        <span className="error">{error.category}</span>

        <label className="label-style mt-16">
          Message
          <span className="required">*</span>
        </label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Message"
          className="input-style text-area"
        />
        <span className="error">{error.message}</span>

        <button type="submit" className={`submit mt-16`} onClick={onSubmit}>
          Submit
        </button>
      </form>
      {showSuccessModal && <SuccessModal id={refId} onClose={onCloseModal} />}
    </div>
  );
};

export default Support;
